import React from "react";
import AuditLogsRoute from "../modules/coinWrap/pages/AuditLogs/AuditLogsRoute";

const AuditLogsPage = () => {
  return <AuditLogsRoute />;
};

export default AuditLogsPage;
